/*************************************************/
/* VISITOR-LOCATION-SITE-SWITCH                  */
/*************************************************/
export function visitorLocationSiteSwitch() {
    const visitorLocationSiteSwitch = document.querySelector('.visitor-location-site-switch');
    const visitorLocationSiteSwitchDismissButton = document.querySelector('.visitor-location-site-switch__dismiss-button');
    const visitorLocationSiteSwitchVisibilityClass = 'visitor-location-site-switch--hidden';
    const visitorLocationSiteSwitchStatusSessionStorageKey = 'hideVisitorLocationSiteSwitcher';

    const dismissVisitorLocationSiteSwitcher = () => {
        visitorLocationSiteSwitch.classList.add(visitorLocationSiteSwitchVisibilityClass);
        sessionStorage.setItem(visitorLocationSiteSwitchStatusSessionStorageKey, true);
    };

    const init = () => {
        if (visitorLocationSiteSwitchDismissButton) {
            visitorLocationSiteSwitchDismissButton.addEventListener('click', dismissVisitorLocationSiteSwitcher);
        }

        if(visitorLocationSiteSwitch){
            if (sessionStorage.getItem(visitorLocationSiteSwitchStatusSessionStorageKey) == null) {
                visitorLocationSiteSwitch.classList.remove(visitorLocationSiteSwitchVisibilityClass);
            }
        }
    };

    init();

}

